/* Preview-only dossier demo — a static, deterministic surface that
 * mounts three HymnRow entries with fully-populated catalog_symbol
 * payloads. Used to visually verify Phase 1.2 rendering in preview
 * environments where live plan generation is blocked (E2E LLM sync).
 *
 * Not routed in production navigation; access via /preview/dossier-demo. */

import React from "react";
import HymnRow from "../components/HymnRow";
import "../pages/WorshipPlanner.css";

// Three Eucharistic hymns matching the seed catalog assignments in
// backend/repertoire/catalog/data/hymns.json. Each carries the exact
// catalog_symbol payload the backend enrichment would attach.
const DEMO_HYMNS = [
  {
    placement: "Communion",
    title: "Gift of Finest Wheat",
    tune: "BICENTENNIAL",
    source: "Catholic Book of Worship III · #576",
    reason: "Corpus Christi · Eucharistic thanksgiving",
    catalog_symbol: {
      primary: "wheat_sheaves",
      glyph: "\uD83C\uDF3E",
      label: "Wheat Sheaves",
      rationale:
        "The hymn names Christ's gift as the finest wheat drawn from a good harvest — the same sheaves the altar frontal offers to the sanctuary.",
    },
  },
  {
    placement: "Communion",
    title: "Take and Eat",
    tune: "TAKE AND EAT",
    source: "Catholic Book of Worship III · #571",
    reason: "Institution narrative · sacramental presence",
    catalog_symbol: {
      primary: "disc_of_host",
      glyph: "\u25C9",
      label: "Disc of the Host",
      rationale:
        "Christ's own institution words — 'take and eat' — sung at the moment the assembly draws near to the sacramental disc of the Host.",
    },
  },
  {
    placement: "Recessional",
    title: "Pange Lingua Gloriosi",
    tune: "PANGE LINGUA",
    source: "Roman Missal · Solesmes",
    reason: "Corpus Christi · Precious Blood",
    catalog_symbol: {
      primary: "grape_clusters",
      glyph: "\uD83C\uDF47",
      label: "Grape Clusters",
      rationale:
        "Aquinas's Corpus Christi hymn keeps its second half on the sanguinis pretiosi — the Precious Blood the altar frontal figures in its clustered vine.",
    },
  },
];

export default function DossierDemo() {
  return (
    <div className="li-body" style={{ minHeight: "100vh", padding: "48px 0" }}>
      <div className="wp-plan" style={{ maxWidth: 900, margin: "0 auto" }}>
        <div style={{ marginBottom: 24 }}>
          <div className="wp-eyebrow" data-testid="dossier-demo-eyebrow">
            Preview · Dossier Demo · Phase 1.2
          </div>
          <h1 className="li-h1" data-testid="dossier-demo-title">
            Suggested Repertoire
          </h1>
          <p
            className="li-caption"
            style={{ marginTop: 6 }}
            data-testid="dossier-demo-subtitle"
          >
            A static preview rendering the three altar-frontal cast marks
            beside their hymns. Click <em>Why this hymn?</em> on any row to
            open the Editorial Discernment panel.
          </p>
        </div>

        <div className="wp-service">
          <div className="wp-service-h">
            <h2>Corpus Christi · Sunday Mass</h2>
            <span>The Most Holy Body and Blood of Christ · White</span>
          </div>
          <div className="wp-hymns">
            <b>Suggested Repertoire</b>
            <ul data-testid="dossier-demo-hymn-list">
              {DEMO_HYMNS.map((h, j) => (
                <HymnRow
                  key={j}
                  jobId={null}
                  serviceIndex={0}
                  hymnIndex={j}
                  hymn={h}
                />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
